import React, { useState } from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaTaxi, FaHotel, FaUserTie, FaSuitcaseRolling, FaUsers } from "react-icons/fa";
import { ts, validatePhoneNumber } from '../utils/metaData';
import { BiSupport } from "react-icons/bi";
import { toast } from 'react-toastify';
import heroImg from '../../assets/Banner.png';
import { Helmet } from "react-helmet";
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const ContactUs = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    name: "",
    phone: "",
    pickup: "",
    drop: "",
    email: ""
  })


  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.name || !data.phone || !data.drop || !data.pickup || !data.email) {
      toast.error("All fields are required.");
      return;
    }

    if (!validatePhoneNumber(data.phone)) {
      toast.error("Invalid Phone Number");
      return;
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        "pid": "INVST"
      }

      const body = JSON.stringify({
        meta: {
          pid: "INVST",
          appName: "bestcab",
          ts: ts(),
          reqAction: "connect",
          location: "N/A",
        },
        pay: {
          phone: data.phone,
          name: data.name,
          pickup: data.pickup,
          drop: data.drop,
          email: data.email
        }
      })
      setLoading(true)
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/user/bestcab/connect`, {
        method: "POST",
        body: body,
        headers: headers,
      })
      const res = await response.json()
      setLoading(false)
      if (res.statusCode == '000') {
        toast.success(res.message)
      }
      else {
        toast.error(res.message)
      }
      setData({
        name: "",
        phone: "",
        pickup: "",
        drop: "",
        email: ""
      })
    } catch (error) {
      toast.error("Something Went Wrong !");
    } finally {
      setLoading(false)
    }
  }


  return (
    <>
      <Helmet>
        <title>Rajasthan Cab Service – Jaipur to Delhi, Manali, Kashmir & More</title>
        <meta
          name="description"
          content="Looking for the best taxi in Jaipur? Book one-way & outstation cabs to Delhi, Manali, Agra, Kashmir & more. Clean cars, expert drivers & 24x7 support."
        />
        <meta
          name="keywords"
          content="Rajasthan cab service, Jaipur taxi, one-way cab, outstation taxi, Jaipur to Delhi, Jaipur to Manali, Jaipur to Kashmir, outstation cabs, taxi booking Jaipur, best taxi service"
        />
      </Helmet>
      <section className="relative h-[30vh] sm:h-[60vh] w-full mt-[70px]">
        <img
          src={heroImg}
          alt="About Hero"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-pink-600/80 to-pink-500/80"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-white px-4 sm:px-10 md:px-20 text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold font-serif">Contact Us</h1>
          <p className="text-lg sm:text-xl md:text-2xl mt-4 max-w-3xl">
            Reach out today for reliable cab bookings and personalized tour package assistance
          </p>
        </div>
      </section>
      <div className="bg-gray-100 py-12 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-6 mt-3">
            We're Here to Help!
          </h2>
          <p className="text-center text-gray-600 max-w-3xl mx-auto">
            Got a travel plan in mind? Need a reliable taxi service, tour package, or hotel booking?
            We’re just a call away! At <strong>The Best Cab by Bharat Tours & Travels</strong>,
            we prioritize customer satisfaction and ensure seamless communication for all your travel needs.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mt-8 text-center">
            <div className="bg-white p-6 rounded-3xl shadow-lg hover:shadow-xl transition">
              <FaPhoneAlt className="text-pink-600 text-4xl mx-auto mb-3" />
              <p className="text-gray-800 font-semibold">Call Us</p>
              <p className="text-gray-600 mt-1">
                <a href="tel:+917976710874">+91-7976710874</a>
              </p>
              <p className="text-gray-600 mt-1">
                <a href="tel:+919116710874">+91-9116710874</a>
              </p>
            </div>

            <div className="bg-white p-6 rounded-3xl shadow-lg hover:shadow-xl transition">
              <FaEnvelope className="text-pink-600 text-4xl mx-auto mb-3" />
              <p className="text-gray-800 font-semibold">Email Us</p>
              <p><a href="mailto:info@thebestcab.in">info@thebestcab.in</a></p>
            </div>

            <div className="bg-white p-6 rounded-3xl shadow-lg hover:shadow-xl transition">
              <FaMapMarkerAlt className="text-pink-600 text-4xl mx-auto mb-3" />
              <p className="text-gray-800 font-semibold">Visit Us</p>
              <p className="text-gray-600 mt-1">Airport Terminal-2,Near Jawahar Circle, Jaipur</p>
            </div>
          </div>

          {/* Services Section */}
          <h3 className="text-3xl font-semibold text-center text-gray-800 mt-12">How Can We Help?</h3>
          <div className="grid md:grid-cols-2 gap-6 mt-6">
            <div className="flex items-center bg-white p-4 rounded-lg shadow">
              <FaTaxi className="text-pink-600 text-3xl mr-3" />
              <p className="text-gray-700">Book a Taxi Instantly – Local & outstation cab services, airport transfers, and city rides.</p>
            </div>
            <div className="flex items-center bg-white p-4 rounded-lg shadow">
              <FaSuitcaseRolling className="text-pink-600 text-3xl mr-3" />
              <p className="text-gray-700">Customized Tour Packages – Tailored trips to explore the best destinations in India.</p>
            </div>
            <div className="flex items-center bg-white p-4 rounded-lg shadow">
              <FaHotel className="text-pink-600 text-3xl mr-3" />
              <p className="text-gray-700">Hotel Stays & Accommodations – Comfortable & budget-friendly lodging options.</p>
            </div>
            <div className="flex items-center bg-white p-4 rounded-lg shadow">
              <FaUserTie className="text-pink-600 text-3xl mr-3" />
              <p className="text-gray-700">Tour Guide Services – Experience expert-led sightseeing with local insights.</p>
            </div>
            <div className="flex items-center bg-white p-4 rounded-lg shadow">
              <FaUsers className="text-pink-600 text-3xl mr-3" />
              <p className="text-gray-700">Corporate & Group Travel – Hassle-free transport for business trips & group tours.</p>
            </div>
            <div className="flex items-center bg-white p-4 rounded-lg shadow">
              <BiSupport className="text-pink-600 text-3xl mr-3" />
              <p className="text-gray-700">24/7 Customer Support – Dedicated assistance anytime to ensure a smooth travel experience.</p>
            </div>
          </div>

          {/* Contact Form */}
          <h3 className="text-3xl font-semibold text-center text-gray-800 mt-12">Get a Call Back</h3>
          <div className="flex justify-center items-start mt-8 px-4">
            <div className="w-full sm:w-11/12 md:w-2/3 lg:w-1/2 xl:w-2/5">
              <div className="bg-white rounded-xl shadow-md p-6 sticky top-6">
                <form className="grid grid-cols-1 gap-4">
                  <input
                    type="text"
                    name="name"
                    value={data.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300"
                    required
                  />

                  <input
                    type="text"
                    name="phone"
                    value={data.phone}
                    onChange={handleChange}
                    placeholder="Phone Number"
                    className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300"
                    required
                  />

                  <input
                    type="mail"
                    name="email"
                    value={data.email}
                    placeholder="Email"
                    onChange={handleChange}
                    className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300"
                    required
                  />

                  <div className="relative">
                    <input
                      type="text"
                      name="pickup"
                      value={data.pickup}
                      onChange={handleChange}
                      placeholder="Pickup"
                      className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300 pl-10"
                      required
                    />
                    <FaMapMarkerAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  </div>

                  <div className="relative">
                    <input
                      type="text"
                      name="drop"
                      value={data.drop}
                      onChange={handleChange}
                      placeholder="Destination"
                      className="w-full p-3 border border-pink-400 rounded-lg text-base focus:ring-2 focus:ring-pink-400 transition duration-300 pl-10"
                      required
                    />
                    <FaMapMarkerAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-pink-600 text-white py-2 rounded-lg hover:bg-pink-500 transition flex justify-center items-center gap-2"
                    disabled={loading}
                    onClick={handleSubmit}
                  >
                    {loading ? (
                      <AiOutlineLoading3Quarters className="animate-spin text-xl" />
                    ) : (
                      'Submit'
                    )}
                  </button>
                </form>

                <div className="mt-4 text-center text-sm text-gray-500">
                  Or call us: <span className="font-semibold">+91-9116710874</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
